import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import DistrictNavbar from './components/district-navbar';
import TourNavbar from './components/tour-navbar';
import DistrictFooter from './components/district-footer';
import useDistrict from '../hooks/useDistrict';
import AppBanner from './app-banner';
const PageLayout = (props) => {
    const { district, banners } = useDistrict();
    const bannerConfigs = useMemo(() => {
        return (banners || []).map(banner => ({
            id: banner.id,
            variant: banner.variant.name,
            message: banner.message,
            dismissible: banner.dismissible,
            showFeedbackLink: banner.show_feedback_link,
            color: banner.color,
        }));
    }, [banners]);
    return (_jsxs(_Fragment, { children: [_jsx(AppBanner, { banners: bannerConfigs }), props.navbar === 'tour'
                ? _jsx(TourNavbar, { district: district })
                : _jsx(DistrictNavbar, { district: district }), _jsx("main", { children: props.children }), _jsx(DistrictFooter, { district: district })] }));
};
export default PageLayout;
